import * as yup from "yup";

const SignInSchema = yup.object().shape({
  email: yup.string().email("Enter valid email").required("Email is Required"),
  password: yup.string().required("Password is required"),
});

const ForgotPasswordSchema = yup.object().shape({
  email: yup.string().email("Enter valid email").required("Email is Required"),
});

const ResetPasswordSchema = yup.object().shape({
  password: yup
    .string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters"),
  passwordConfirmation: yup
    .string()
    .required("Password Confirmation is required")
    .oneOf([yup.ref("password"), null], "Passwords must match"),
});

export { SignInSchema, ForgotPasswordSchema, ResetPasswordSchema };
